var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"default-content"},[_c('p',{staticStyle:{"font-size":"14px"}},[_vm._v("请点击右侧结算单清单详情， 设置开票")])])])
}]

export { render, staticRenderFns }